const ListCard = ({ title, name, listItems }) => {
  return (
    <div>
      <h4 className="view-heading">{title}</h4>
      <section>
        <ul htmlFor="name">
          {listItems?.length > 0
            ? listItems?.map((item) => <li>{item.name}</li>)
            : null}
        </ul>
      </section>
    </div>
  );
};

export default ListCard;
